module.exports = __webpack_public_path__ + "img/icon-left-row.a2b72012.png";